import React, { useState, useEffect } from "react";
import { auth } from "../../firebase-config";
import { db, storage } from '../../firebase-config';
import {
  collection,
  addDoc,
  onSnapshot,
  query,
  orderBy,
  serverTimestamp,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { TextField } from "@mui/material";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Cookies from "universal-cookie";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

const cookies = new Cookies(); 

function Notifications() {

  const [fileupload, setFileupload] = useState(null);
  const [movies, setMovies] = useState("");
  const [title, setTitle] = useState("");
  const [imagePreview, setImagePreview] = useState("https://t4.ftcdn.net/jpg/01/64/16/59/360_F_164165971_ELxPPwdwHYEhg4vZ3F4Ej7OmZVzqq4Ov.jpg");

  const moviesCollectionRef = collection(db, "movies");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFileupload(file);
    
    // Display image preview
    const reader = new FileReader();
    reader.onload = () => {
      setImagePreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleUpload = async () => {
    if (!fileupload) {
      alert("Please select a file");
      return;
    }

    try {
      const filesFolderRef = ref(storage, `projectFiles/${fileupload.name}`);
      await uploadBytes(filesFolderRef, fileupload);
      const downloadURL = await getDownloadURL(filesFolderRef);

      await addDoc(moviesCollectionRef, {
        date: downloadURL,
        createdAt: serverTimestamp(),
        text: movies,
        title: title,
        username:(cookies.get('auth-token1') && cookies.get('auth-token1').userName) || 'USERNAME',
        mid: auth?.currentUser?.uid,
        pfpimage: auth?.currentUser?.photoURL
      });

      alert("Successfully Submitted");
      setMovies("")
      setFileupload(null)
      setImagePreview(null)
    } catch (err) {
      console.error(err);
    }
  };


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
      {cookies.get('auth-token1') ?
          (
      <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} sm={6}>
            <Card>
              <MDBox p={3}>
                <input 
                  type="file" 
                  onChange={handleFileChange} 
                  style={{ display: 'none' }} 
                  id="file-upload"
                />
                <label htmlFor="file-upload">
                  <MDButton
                    variant="contained"
                    color="info"
                    component="span"
                  >
                    Upload Image
                  </MDButton>
                </label>
                {imagePreview && (
                  <img 
                    src={imagePreview} 
                    alt="Preview" 
                    style={{ width: '100%', height: 'auto', marginTop: '20px', marginBottom: '10px' }} 
                  />
                )}
                <TextField
                  id="outlined-multiline"
                  label="Title"
                  multiline
                  variant="outlined"
                  value={title}
                  onChange={(event) => setTitle(event.target.value)}
                  fullWidth
                  style={{ marginTop: "2rem"}}
                />
                <TextField
                  id="outlined-multiline"
                  label="Content"
                  multiline
                  rows={4}
                  variant="outlined"
                  value={movies}
                  onChange={(event) => setMovies(event.target.value)}
                  fullWidth
                  style={{ marginTop: "1rem", marginBottom: "1rem" }}
                />
                <MDButton 
                  variant="contained"
                  color="info"
                  onClick={handleUpload}
                  fullWidth
                >
                  Upload
                </MDButton>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
          ):(
            <h1 style={{textAlign: "center"}}>SIGN IN  FIRST</h1>
          )}
      </MDBox>
      
    </DashboardLayout>
  );
}

export default Notifications;
